/**
 * @created on 2017/9/19
 * @author laixinyu <laixinyualex@gmail.com>
 **/

function getRunTime(str) {
  let result
  let _href = window.location.href.split('.')[0]

  _href.replace(/-(qc\d?|box\d?)/, (s, v) => {
    result = str.replace(/\./, `-${v}.`)
  })

  if (!result) {
    result = str
  }

  return result
}
// 判断环境
let HOST = getRunTime('//m.xinli001.com')

module.exports = {
  HOST,
  login: `${HOST}/account/login`
}



// WEBPACK FOOTER //
// ./src/public-resource/logic/Apis.js